import { Table, Card, Tabs, Button } from 'antd';
import React from 'react';
import {ListBase, ListProps, useListContext, Record } from 'react-admin';
import {Link} from "react-router-dom";
import SkeletonTable, { SkeletonTableColumnsType } from '../Common/SkeletonTable';
import DependantServices from './DependantServices';
import {onExpandIcon, tableOnChangeGenerator, useExpandableRows} from "../Common/tableUtils";
import LazyExpandedRow from "../Common/LazyExpandedRow";
import ServiceRow from "./ServiceRow";
import { PlusOutlined } from '@ant-design/icons';
import { isVisibleCreateServiceButton } from './utils';



const ListView = () => {
  const { ids, data, loading, total, perPage, setPage, page, setPerPage, setSort } = useListContext();
  const { expandedRowKeys, onExpand, toggleRowExpansion } = useExpandableRows('name');

  const columns = [
    {
      title: 'Service Name',
      dataIndex: 'name',
      key: 'name',
      sorter: true
    },
    {
      title: 'Description',
      key: 'description',
      render: (text: any, record: any) => record?.schema?.schema?.description
    },
  ]

  const tableData: Record[] = []
  ids.forEach(id => {
    tableData.push(data[id])
  });
  return (
    <Card
      bordered={false}
      className="criclebox tablespace mb-24"
      extra={isVisibleCreateServiceButton() && <Link to="/services/create"><Button type='primary' icon={<PlusOutlined />}>Create Service</Button></Link>}
    >
      <Tabs style={{ paddingLeft: '24px' }} defaultActiveKey='1' items={[
        {
          key: '1',
          label: 'Team Services',
          children: (
            <SkeletonTable loading={loading} columns={columns as SkeletonTableColumnsType[]}>
              <Table
                rowKey='name'
                columns={columns}
                pagination={{
                  pageSizeOptions: [25, 50, 100],
                  onShowSizeChange: (_current, size) => setPerPage(size),
                  showSizeChanger: true,
                  total: total,
                  pageSize: perPage,
                  current: page,
                  className: "pagination-padding",
                }}
                dataSource={tableData}
                onChange={tableOnChangeGenerator(setSort, page, setPage)}
                expandable={{
                  onExpand,
                  expandRowByClick: true ,
                  expandedRowRender: (record) => <LazyExpandedRow lightRecord={record} resource={"services"} ExpandedRowComponent={ServiceRow}/>,
                  expandIcon: onExpandIcon(toggleRowExpansion, onExpand),
                  expandedRowKeys: expandedRowKeys
                }}
              />
            </SkeletonTable>
          ),
        },
        {
          key: '2',
          label: 'Dependant Services',
          children: <DependantServices />,
        },
      ]} />

    </Card>
  )
}

const ServiceList = (props: ListProps) => (
  <ListBase perPage={25} {...props}>
    <ListView />
  </ListBase>
)

export default ServiceList;
